import { Form } from 'antd';
import { Button, Colors, IcPlus, InputSearch, Row, Text } from 'basic-ui-lib';
import { useCallback, useState } from 'react';
import styled from 'styled-components';
import NewChannelModal from '../NewChannelModal';
import useGetListChannels from 'modules/channel/services/hooks/useGetListChannels';
import useDebounce from 'hooks/useDebounce';

const ChannelFilter = () => {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [, mutate] = useGetListChannels(true);

  const onSearchDebounce = useCallback((value: string) => {
      mutate({ from: 1, size: 10, keySearch: value });
  }, []);

  const { text: searchText, setText: setSearchText } = useDebounce({
    timeDebounce: 600,
    onDebounce: onSearchDebounce,
  });

  return (
    <Container>
      <Form form={form} layout='vertical' className='form-container'>
        <Row width='45%'>
          <Text title_h2 semibold>
            Channels
          </Text>
        </Row>
        <Row gap={16} width='55%' justifyContent='flex-end'>
          <Form.Item name='keySearch' noStyle>
            <InputSearch placeholder='Search channel name' value={searchText} onChange={(value) => setSearchText(value)} />
          </Form.Item>
          <Button type_second lg type='button' prefix={<IcPlus fill={Colors.neutral.bg[1]} width={20} height={20} />} onClick={() => setOpen(true)}>
            Add Channel
          </Button>
        </Row>
      </Form>
      <NewChannelModal isOpen={open} onClose={() => setOpen(false)} />
    </Container>
  );
};

export default ChannelFilter;

const Container = styled.div`
  width: 100%;

  .form-container {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .custom-text {
    white-space: nowrap;
  }
`;
